import Model from '../BaseModel'
import Reseller from '../Reseller'
import Product from './Product'
import ProductSalePeriod from './ProductSalePeriod'
import i18n from '@/plugins/i18n'
import axios from '@/plugins/axios'

export default class ProductSale extends Model {
    resourceName() {
        return 'product-sales'
    }

    fields() {
        return [
            'product_id',
            'reseller_id',
            'price',
            'installments',
            'payment_method',
            'first_due_date',
            'reseller_name',
            'product_name',
            'charge',
            'charged',
            'down_payment',
            'status',
        ]
    }

    async simulate() {
        return await axios.post(`${this.resourceUrl()}simulate`, this.data())
    }

    async sync() {
        return await axios.post(`${this.getSelfUrl()}/sync`, this.data())
    }

    relationships() {
        return {
            product: new Product(),
            reseller: new Reseller(),
            productSalePeriod: new ProductSalePeriod(),
        }
    }

    computed() {
        return {
            formattedPrice(productSale) {
                return i18n.n(productSale.price, 'currency')
            },
            formattedPaymentMethod(productSale) {
                return i18n.t(
                    `resources.productSale.getters.payment_method.${productSale.payment_method}`,
                )
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.productSale.attributes.reseller_name'),
                value: 'reseller_name',
            },
            {
                text: i18n.t('resources.productSale.attributes.product_name'),
                value: 'product_name',
            },
            {
                text: i18n.t('resources.productSale.attributes.price'),
                value: 'formattedPrice',
            },
            {
                text: i18n.t('resources.productSale.attributes.installments'),
                value: 'installments',
            },
            {
                text: i18n.t('resources.productSale.attributes.payment_method'),
                value: 'formattedPaymentMethod',
            },
            {
                text: i18n.t('resources.productSale.attributes.charged'),
                value: 'charged',
            },
            {
                text: i18n.t('resources.productSale.attributes.status'),
                value: 'status',
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
            { text: '', value: 'data-table-expand' },
        ]
    }

    get statusColor() {
        switch (this.status) {
            case 'Pendente':
                return 'orange'
            case 'Processando':
                return 'blue'
            case 'Em dia':
                return 'grey'
            case 'Pago':
                return 'green'
            case 'Atrasado':
                return 'red'
        }

        return 'black'
    }
}
